import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, formatPrice, API } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

async function downloadCsv(path, filename) {
    const token = localStorage.getItem("ost_token") || "";
    const res = await fetch(`${API}${path}`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error("Download failed");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

export default function AdminCustomers() {
    const { settings } = useSettings();
    const cur = settings?.currency_symbol || "Rs.";
    const [items, setItems] = useState([]);
    const [exporting, setExporting] = useState(false);
    useEffect(() => {
        api.get("/admin/customers").then((r) => setItems(r.data || []));
    }, []);
    const exportCsv = async () => {
        setExporting(true);
        try {
            await downloadCsv("/admin/exports/customers.csv", `opensea-customers-${new Date().toISOString().slice(0,10)}.csv`);
        } catch (_) {}
        setExporting(false);
    };

    return (
        <div className="space-y-5" data-testid="admin-customers-page">
            <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                    <div className="text-xs uppercase tracking-[0.3em] text-[#00BCE5] font-display font-semibold">CRM</div>
                    <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Customers</h1>
                </div>
                <button
                    onClick={exportCsv}
                    disabled={exporting}
                    className="inline-flex items-center gap-2 border border-[#27272A] hover:border-[#00BCE5] hover:text-[#00BCE5] text-white px-4 py-2.5 rounded-sm font-display font-semibold uppercase tracking-widest text-sm disabled:opacity-50"
                    data-testid="customers-export-csv"
                >
                    <Download size={14} /> {exporting ? "Exporting…" : "Export CSV"}
                </button>
            </div>

            <div className="bg-[#18181B] border border-[#27272A] rounded-sm overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-[#121214] text-xs uppercase tracking-widest font-display text-white/55">
                        <tr>
                            <th className="px-3 py-2 text-left">Name</th>
                            <th className="px-3 py-2 text-left">Phone</th>
                            <th className="px-3 py-2 text-left">Email</th>
                            <th className="px-3 py-2 text-left">Location</th>
                            <th className="px-3 py-2 text-left">Orders</th>
                            <th className="px-3 py-2 text-left">Spend</th>
                            <th className="px-3 py-2 text-left">Last order</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((c, i) => (
                            <tr key={i} className="border-t border-[#27272A]" data-testid={`customer-row-${i}`}>
                                <td className="px-3 py-2 text-white">{c.name}</td>
                                <td className="px-3 py-2 text-white/65">{c.phone}</td>
                                <td className="px-3 py-2 text-white/65">{c.email || "—"}</td>
                                <td className="px-3 py-2 text-white/85">{[c.city, c.state].filter(Boolean).join(", ")}</td>
                                <td className="px-3 py-2">{c.orders}</td>
                                <td className="px-3 py-2">{formatPrice(c.total_spend, cur)}</td>
                                <td className="px-3 py-2 text-white/55">{c.last_order ? new Date(c.last_order).toLocaleDateString() : "—"}</td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr><td colSpan={7} className="px-3 py-8 text-center text-white/55">Customers will appear here once orders come in.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
